export default __webpack_public_path__ + "static/media/Inter-Regular.f80c55a7.woff2";